export default __webpack_public_path__ + "static/media/bg7.c0051f17.jpg";